<template>
  <div
    class="flex min-h-[65px] w-full flex-col gap-2.5 rounded-[20px] bg-white-gray px-4 py-3.5 min-[1120px]:flex-row min-[1120px]:items-center xl:px-5 xl:py-4"
  >
    <DeliveryDatePicker
      :model-value="modelValue"
      @update:model-value="emit('update:modelValue', $event)"
    />

    <button
      type="button"
      class="h-[42px] w-full min-w-[120px] rounded-[10px] border border-gray-dark px-4 text-[17px] leading-[1.4] font-helvetica-400 text-gray-dark transition-colors cursor-pointer disabled:bg-gray-border disabled:border-gray-border disabled:text-gray-light disabled:hover:bg-gray-border disabled:hover:border-gray-border disabled:hover:text-gray-light disabled:cursor-not-allowed hover:bg-white min-[1120px]:ml-auto min-[1120px]:w-auto xl:h-[44px] xl:px-5 xl:text-[18px]"
      @click="emit('show')"
    >
      Показать
    </button>
  </div>
</template>

<script setup lang="ts">
import DeliveryDatePicker from "~/components/delivery/DeliveryDatePicker.vue";

type Range = { from: string | null; to: string | null };

defineProps<{
  modelValue?: Range;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: Range): void;
  (e: "show"): void;
}>();
</script>
